import { Navigate, Outlet } from 'react-router-dom';

import { Box, SxProps, Theme } from '@mui/material';

import { useUserDataStore } from '../../newStore/userDataStore';
import { paths } from '../../utils/navigation';
import { OverlayLoader } from '../uiComponents/CommonComponents/OverlayLoader';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    display: 'flex',
    height: '100vh',
    overflow: 'hidden',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  main: {
    flexGrow: 1,
    overflow: 'auto',
    background: '#FAFBFF',
    position: 'relative',
  },
};

export function VideoLayout() {
  const currentUser = useUserDataStore((state) => state.currentUser);
  const fetchedUserData = useUserDataStore((state) => state.fetchedUserData);
  const loading = useUserDataStore((state) => state.loading);

  if (loading && !fetchedUserData) return <OverlayLoader open />;

  if (!currentUser?.id && !currentUser?.is_support && fetchedUserData)
    return (
      <Navigate
        to={paths.auth.login}
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );

  // Make sure users that haven't completed onboarding can't bypass it
  if (currentUser?.id && !currentUser?.onboarding_completed && currentUser?.is_superadmin) {
    return <Navigate to={paths.onboarding.index} />;
  }

  return (
    <Box sx={customStyles.root}>
        <Box
          component='main'
          sx={customStyles.main}
        >
        <Outlet />
      </Box>
    </Box>
  );
}
